<template>
  <section class="app-main">
<!--    面包屑视图-->
          <section class="breadcrumb-view">
            <Breadcrumb/>
          </section>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <!-- <logo/>  -->
  </section>
</template>

<script>
import logo from './logo'
import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'AppMain',
  components: {
    logo,
    Breadcrumb
  },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: var(--main-container-height);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #F4F4F7;
  border-top: 1px solid #f0f0f0;
  overflow: auto;
  height: var(--main-container-height);
  padding-left: 10px;
  /*background: url(../../assets/main-app-background.png) no-repeat;*/
  /*background-position: center bottom ;*/
  /*background-size: 75vw auto;*/
}
.fixed-header + .app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue